/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import PropTypes from "prop-types";
import { useMemo } from "react";
import useAlertInfo from "../../hooks/use-alert-info";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const SnackbarItem = ({
  alert: { msg, type, duration },
  open,
  handleClose,
  handleExited,
  ...props
}) => {
  const { getIcon, getIconColor } = useAlertInfo();
  const Icon = getIcon(type, true);

  // ✅ UseMemo to avoid recalculating the background color
  const backgroundColor = useMemo(
    () => getIconColor(type),
    [type, getIconColor]
  );

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      autoHideDuration={duration || 6000}
      onClose={handleClose}
      disableWindowBlurListener
      message={
        <span
          id="message-id"
          css={css`
            display: flex;
            align-items: center;
            word-break: break-word;
          `}
        >
          <Icon
            css={css`
              font-size: 20px;
              opacity: 0.9;
              margin-right: 8px;
            `}
          />
          {msg}
        </span>
      }
      action={
        <IconButton key="close" color="inherit" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      }
      slotProps={{
        content: {
          sx: {
            backgroundColor, // ✅ Replace ContentProps.classes.root
          },
        },
        ...props,
        transition: {
          ...props?.transition,
          onExited: handleExited, // ✅ still works reliably
        },
      }}
    />
  );
};

SnackbarItem.propTypes = {
  alert: PropTypes.shape({
    msg: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["success", "critical", "error", "warning", "info"])
      .isRequired,
    duration: PropTypes.number,
  }).isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleExited: PropTypes.func.isRequired,
};

export default SnackbarItem;
